((function() {
  if (!document.body.classList.contains('store-locator')) {
    return;
  }

  var mainContent = document.getElementById('MainContent');
  var styleId = 'store-locator-inline-styles';

  function ensureStoreLocatorStyles() {
    if (document.getElementById(styleId)) {
      return;
    }

    var style = document.createElement('style');
    style.id = styleId;
    style.textContent =
      ".store-locator .transition-content," +
      ".store-locator [id='MainContent']{background-color:#fff;}" +
      ".store-locator [id='MainContent']{position:relative;z-index:1;}" +
      ".store-locator .store-locator-section{display:flow-root;position:relative;z-index:1;}" +
      ".store-locator .shopify-section-group-footer-group{position:relative;z-index:0;}";
    document.head.appendChild(style);
  }

  function findStoreLocatorSection() {
    if (!mainContent) {
      return null;
    }

    return Array.from(mainContent.children).find(function(section) {
      return (
        section instanceof HTMLElement &&
        section.querySelector(
          'input[placeholder="Enter a location"], iframe[src*="google"], [class*="storelocator"], [id*="storelocator"]'
        )
      );
    });
  }

  function markStoreLocatorSection() {
    var section = findStoreLocatorSection();
    if (!section) {
      return;
    }

    ensureStoreLocatorStyles();
    section.classList.add('store-locator-section');
  }

  var observer = new window.MutationObserver(markStoreLocatorSection);

  if (mainContent) {
    observer.observe(mainContent, { childList: true, subtree: true });
  }

  window.addEventListener('load', markStoreLocatorSection, { once: true });
  setTimeout(markStoreLocatorSection, 500);
  setTimeout(markStoreLocatorSection, 1500);
})());
